import { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import axios from "axios";

/** Не дергать /api/protected/user здесь — иначе 401 → refresh → редирект на /login и цикл перезагрузки */
const SKIP_USER_FETCH = ["/login", "/register"];

const useAuth = () => {
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true);
    const location = useLocation();

    useEffect(() => {
        if (SKIP_USER_FETCH.includes(location.pathname)) {
            setLoading(false);
            return;
        }

        const initAuth = async () => {
            setLoading(true);
            try {
                const res = await axios.get("/api/protected/user");
                setUser(res.data.user);
            } catch {
                setUser(null);
            } finally {
                setLoading(false);
            }
        };

        initAuth();
    }, [location.pathname]);

    return { user, setUser, loading };
};

export default useAuth;
